require('@babel/polyfill');

const environment = {
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'development'];
module.exports = Object.assign({
  host: (process.env.HOST),
  port: process.env.PORT,
  apiPath: process.env.APIPATH,
  wsRatePath: process.env.WSRATEPATH,
  wsOrderPath: process.env.WSORDERPATH,
  webSocketTimeOut: 5000,
  instrument_listHeader: 'Market Snapshot',
  Trade_Panel_Header: 'Trading Widget',
  CmdtyHeader: 'Pair',
  BidHeader: 'Bid',
  AskHeader: 'Ask',
  highHeader: 'High',
  lowHeader: 'Low',
  prevHeader: 'Previous close',
  QuantityHeader: 'Quantity',
  ChartHeader: 'Chart',
  OutstandingOrderHeader: 'Trade Book',
  TradebookHeader: 'Trade Book',
  Activity_news_Header: 'Activity Log | News Feed',
  ChartHeader: 'Chart',
  Payment_Request_Header: 'Payment Requests',
  SwapRatesComponentHeader: 'Swap Rates',
  heartBeatTime: 5000,
  roundOff: 2,
  AmountRoundOFF: 2,
  QuantityRoundOff: 3,
  companyList: window._env.companyList,
  buy: 'BUY',
  sell: 'SELL',
  SwapCmdtyHeader: 'Cmdty',
  MMMHeader: 'MMM (%)',
  SwapBidHeader: 'BID (%)',
  SwapAskHeader: 'ASK (%)',
  PrintCommRate: window._env.PrintCommRate,
}, environment);
